<template>
    <div class="article-home-hero">
        <p class="text-2xl">Unleash the power of Atomic Stacks</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomeHero',
};
</script>
